// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import axiosBaseQuery from "./axiosBaseQuery";

// Define a service using a base URL and expected endpoints
export const saturnAPI = createApi({
	reducerPath: "saturnAPI",
	baseQuery: axiosBaseQuery({ baseUrl: "https://engine.novaleap.net/api" }),
	tagTypes: ["Items"],
	endpoints(build) {
		return {
			subscribeToNewsletter: build.mutation({        
				query: (vmNewsletterSubscription) => ({
				  url: "/newslettersubscriptions",
				  method: "POST",
				  data: {
					email: vmNewsletterSubscription.email.trim(),         
				  }
				})
			  }),
			  createContactForm: build.mutation({        
				query: (vmContactForm) => ({
				  url: "/contact-forms",
				  method: "POST",
				  data: {
					fullName: vmContactForm.fullName,
					email: vmContactForm.email,
					organizationName: vmContactForm.organizationName,
					phoneNumber: vmContactForm.phoneNumber,
					message: vmContactForm.message,
				  }
				})
			  }),		
			  createAssessmentRequest: build.mutation({        
				query: (vmAssessmentReqForm) => ({
				  url: "/assessment-requests",
				  method: "POST",
				  data: {
					fullName: vmAssessmentReqForm.fullName,
					email: vmAssessmentReqForm.email,
					organizationName: vmAssessmentReqForm.organizationName,
					jobTitle: vmAssessmentReqForm.jobTitle,
					website: vmAssessmentReqForm.website,					
					staffHeadcount: vmAssessmentReqForm.staffHeadcount,
					phoneNumber: vmAssessmentReqForm.phoneNumber,
				  }
				})
			  }),				  	  
		};
	},
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useSubscribeToNewsletterMutation, useCreateContactFormMutation, useCreateAssessmentRequestMutation } = saturnAPI;
